export const preventUnload = event => {
  event.preventDefault()
  event.returnValue = ''
}

export const interceptNavigator = (navigator, onBlock) => {
  const { push, replace } = navigator

  navigator.push = (...args) => onBlock({ navigate: () => push.apply(navigator, args) })
  navigator.replace = (...args) => onBlock({ navigate: () => replace.apply(navigator, args) })

  return () => {
    navigator.push = push
    navigator.replace = replace
  }
}
